import Pagination from '@material-ui/lab/Pagination'
import { useGridSlotComponentProps } from '@mui/x-data-grid'
import { makeStyles, IconButton } from '@material-ui/core'
import useTranslate from '../../../i18n/useTranslate'

const CustomPagination = () => {
    const { state, apiRef } = useGridSlotComponentProps()
    const classes = useStyles()

    return (
        <Pagination
            className={classes.root}
            color="primary"
            variant="outlined"
            shape="rounded"
            count={state.pagination.pageCount}
            page={state.pagination.page + 1}
            onChange={(event, value) => apiRef.current.setPage(value - 1)}
        />
    )
}
const useStyles = makeStyles(() => ({
    root: {
        '& .header-table': {
            backgroundColor: '#DB5F8E',
            color: '#FFFFFF',
        },
        '& .MuiDataGrid-iconSeparator': {
            display: 'none',
        },

        '& .MuiDataGrid-sortIcon': {
            color: '#FFFFFF',
        },
        '& .MuiBadge-anchorOriginTopRightRectangle': {
            display: 'none',
        },
        '& .MuiDataGrid-cell:focus-within': {
            outline: 'none',
        },
    },
}))

export default CustomPagination
